import { useLocation } from 'react-router-dom'

import { ChangePasswordForm } from '../../components/ChangePasswordForm'
import { Footer } from '../../components/Footer'

import styles from './styles.module.scss'

export const RecoveryPassword = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const token = searchParams.get('token')

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.card}>
          <ChangePasswordForm title="Recuperação de senha" token={`${token}`} />
        </div>
      </div>
      <div className={styles.footer}>
        <Footer />
      </div>
    </div>
  )
}
